import { observer } from 'mobx-react'
import React, { Component } from 'react'

import QuestionOptionStore from './QuestionOptionStore'
import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'
import DataTable from '../../../DataTable'

@observer
class QuestionOptionLabels extends Component {
    constructor(props) {
        super(props)
        this.store = props.store
        this.questionOptionStore = new QuestionOptionStore(this.store)
    }

    componentDidMount() {
        this.store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'questionoptionlangs',
                url: '/intranet/questionoptionlangs',
                title: 'Question Option Labels',
            },
        ]
    }

    renderFilters() {
        const { handleInput, handleSubmit } = this.questionOptionStore

        return (
            <Panel cssClass="filterPanel">
                <label> Question Id</label>
                <input type="text" className="inputFeild" onChange={(e) => handleInput(e)} />
                <Button cssClass="submitButton" onClick={handleSubmit}> Submit </Button>
            </Panel>
        )
    }

    renderTable() {
        const { data, columns } = this.questionOptionStore
        return (
            <DataTable
                store={{ filteredList: data }}
                dataSet={data}
                columns={columns}
            />
        )
    }

    render() {
        const { data } = this.questionOptionStore
        return (
            <div id="questionOption">
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '25%' }}>
                        {this.renderFilters()}
                    </div>
                    {data.length > 0 ? (
                        <div style={{ width: '75%' }}>
                            <Panel>
                                {this.renderTable()}
                            </Panel>
                        </div>
                    ) : null}

                </div>

            </div>
        )
    }
}
export default QuestionOptionLabels
